import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { CALLBACK__void } from '@shared/types/types';

interface Props {
  total_ram_amount: number;
  on_click: CALLBACK__void;
}

export function ReservationCreateButton({ on_click, total_ram_amount }: Props) {
  return (
    <UI_PRIMITIVE__button
      variant={'no-border-on-bar'}
      onClick={on_click}
      className="border rounded-lg border-component-border w-[200px] h-[40px] bg-component-items"
    >
      Create: {total_ram_amount}
    </UI_PRIMITIVE__button>
  );
}
